
















import { Form, FormItem, Input, Button } from 'element-ui'
import NProgress from 'nprogress'
import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'
import { Location, Route } from 'vue-router'

import BookingTopNav from '@/components/BookingTopNav.vue'
import CustomerReview from '@/components/CustomerReview.vue'
import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'
import ReviewForm from '@/components/ReviewForm.vue'

import Review from '@/models/review'

import BookingHeaderTitleMixin from '@/mixins/BookingHeaderTitleMixin.vue'
import store from '@/store'
import { BookingsActionTypes } from '@/store/modules/bookings'
import { ReviewActionTypes } from '@/store/modules/reviews'

@Component({
  components: {
    CustomerReview,
    ReviewForm,
    BookingTopNav,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    LoadingPlaceholder,
  },
})
export default class ReviewPage extends mixins(BookingHeaderTitleMixin) {
  mounted() {
    this.initialSetup(this.$route.params.id)
  }

  beforeRouteUpdate(to: Route, from: Route, next: (to?: Location) => void) {
    this.initialSetup(to.params.id)
    next()
  }

  initialSetup(bookingId: string) {
    this.$store.dispatch(BookingsActionTypes.Get, bookingId)
    NProgress.start().set(0.6)
    store.dispatch(ReviewActionTypes.GetCustomerReview, bookingId).then(() => {
      NProgress.done()
    })
  }

  get customerReview(): Review | null {
    return this.$store.getters.getCurrentCustomerReview
  }

  get reviewLoaded(): boolean {
    return this.$store.state.reviews.reviewLoaded
  }

  get bookingId() {
    return this.$route.params.id
  }

  submitReview(review: Review) {
    const bookingId = this.bookingId
    this.$store.dispatch(ReviewActionTypes.Submit, { review, bookingId })
  }
}
